module.exports = __webpack_public_path__ + "img/mission-statement-desktop.371078e8.svg";